
import {
    Flex, Heading, HStack, Icon, Spacer, Button, Switch, Avatar, Text,
    MenuGroup, MenuList, MenuItem, MenuDivider, MenuButton, Menu,
    useColorMode, useColorModeValue as colorValue, Hide, useBreakpointValue as breakptValue, IconButton
} from '@chakra-ui/react'
import { FcDepartment } from "react-icons/fc";
import { BsPencilSquare, BsSun, BsMoon, BsPower, BsPersonSquare, BsBook, BsUnlock, BsChevronBarDown, BsList } from "react-icons/bs";
import { useUserContext, logout, removeLocalUserData } from '../../context/userContext';
import { Link, useHistory } from 'react-router-dom'

export const Logo = () => {
    return (
        <HStack align="center">
            <Link to="/">
                <Heading color={colorValue("blue.600", "white")} size="md" >
                    <Icon as={FcDepartment} mr={3} />
                    <Hide below='md'>{process.env.REACT_APP_NAME}</Hide>
                    <Hide above='md'>{process.env.REACT_APP_EN_NAME}</Hide>
                </Heading>
            </Link>
        </HStack>
    )
}

const RightMenuDefault = () => {

    return (
        <HStack>
            <Link to="/register">
                <Button leftIcon={breakptValue({ base: (null), md: <BsPencilSquare /> })}
                    variant="solid" colorScheme="blue" size="sm">
                    <Hide below='sm'>สมัคร</Hide><Hide below='md'>ใช้งาน</Hide>
                    <Hide above='sm'><Icon as={BsPencilSquare} /></Hide>
                </Button>
            </Link>
            <Menu>
                <MenuButton as={Button} variant="solid" size="sm" colorScheme="teal"
                    rightIcon={breakptValue({ base: (null), md: <BsChevronBarDown /> })}>
                    <Hide below='sm'>คู่มือ</Hide><Hide below='md'>และเอกสาร</Hide>
                    <Hide above='sm'><Icon as={BsBook} /></Hide>
                </MenuButton>
                <MenuList>
                    <MenuGroup title="คู่มือการใช้งานและเอกสารอื่นๆ" >
                        <Link to="/manual">
                            <MenuItem icon={<BsBook />}>คู่มือการใช้งาน</MenuItem>
                        </Link>
                        <Link to="/regulations">
                            <MenuItem icon={<BsBook />}>กฎ ระเบียบ</MenuItem>
                        </Link>
                    </MenuGroup>
                </MenuList>
            </Menu>
        </HStack>
    )
}

const RightMenuAuthorized = () => {
    const { userData, dispatchUserData } = useUserContext()
    let history = useHistory()

    const onLogoutHandle = () => {
        dispatchUserData(logout())

        removeLocalUserData()
        history.push("/")
    }
    return (
        <HStack align="center" spacing={0}>
            <Menu>
                <MenuButton as={Button} variant="ghost" size="sm" rightIcon={<BsChevronBarDown />}>
                    <Flex justify="space-between" align="center">
                        <Avatar size="xs" mr={2} />
                        <Hide below="md">{userData.full_name}</Hide>
                    </Flex>
                </MenuButton>
                <MenuList>
                    <Flex p={4}>
                        <HStack spacing={2}>
                            <Avatar size="md" />
                            <Flex direction="column">
                                <Text fontSize="sm" fontWeight="bold"> {userData.full_name}</Text>
                                <Text fontSize="sm" colorScheme="gray"> {userData.position}</Text>
                            </Flex>
                        </HStack>
                    </Flex>
                    <MenuGroup title="ข้อมูลบัญชีผู้ใข้">
                        <Link to="/profile?menu=1">
                            <MenuItem icon={<BsPersonSquare />}>บัญชีผู้ใช้</MenuItem>
                        </Link>
                        <Link to="/profile?menu=3">
                            <MenuItem icon={<BsUnlock />}>เปลี่ยนรหัสผ่าน</MenuItem>
                        </Link>
                    </MenuGroup>
                    <MenuDivider />
                    <MenuItem icon={<BsPower />} onClick={onLogoutHandle} color="red">
                        ออกจากระบบ
                    </MenuItem>
                </MenuList>
            </Menu>
        </HStack>
    )
}

const RightMenu = () => {

    const { userData } = useUserContext()

    return (
        <HStack spacing={2} align="center">
            <SwitchColorButton />
            {
                userData.authorized ? <RightMenuAuthorized /> : <RightMenuDefault />
            }
        </HStack>
    )
}

const SwitchColorButton = () => {
    const { colorMode, toggleColorMode } = useColorMode()
    return (
        <HStack verticalAlign={"center"}>
            {colorMode === 'light' ? <Icon as={BsSun} /> : <Icon as={BsMoon} />}
            <Switch size='sm' onChange={toggleColorMode} />
        </HStack>
    )
}

const HambergerButton = ({ sidebarOpen })=>{
    const { userData } = useUserContext()
    return (
            userData.authorized ? <IconButton
            aria-label="Menu"
            display={{ base: "inline-flex", md: "none" }}
            onClick={sidebarOpen}
            icon={<BsList />}
            size="sm"
            ml={2} 
        /> : (<></>)
    )
}

const Header = ({ sidebarOpen }) => {
    return (
        <Flex h="60px" align="center" p={5} shadow="lg" position="fixed" left="0" top="0" w="full" zIndex={3} bgColor={colorValue("white", "gray.800")}>
            <Logo />
            <HambergerButton sidebarOpen={sidebarOpen}/>
            <Spacer />
            <RightMenu />
        </Flex>
    )
}

export default Header
